import { NotificationProvider } from "../notification";
import { ModalProvider } from "../modal/ModalContext";
import { MotionProvider } from "./MotionContext";
import { ViewportProvider } from "./ViewportContext";

export const AllProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <ViewportProvider>
      <NotificationProvider>
        <ModalProvider>
          <MotionProvider>{children}</MotionProvider>
        </ModalProvider>
      </NotificationProvider>
    </ViewportProvider>
  );
};
